import React, { useContext, useState, useEffect } from 'react';
import { RicosContext, ModalContext, EditorContext } from 'ricos-context';
import { pollModals } from '../../consts.js';
import { POLL_TYPE } from '../../types.js';
import { SettingsModal } from '../settings/SettingsModal.js';
import 'ricos-schema';
import '../settings/constants.js';
import 'classnames';
import 'prop-types';
import 'react-modal';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import '../../dataHooks.js';
import '../../viewer/poll-viewer.js';
import 'wix-rich-content-editor-common/libs/EditorEventsContext';
import '../rce-helpers-context/index.js';
import '../../viewer/poll-component.js';
import 'react-flip-move';
import 'react-measure';
import '../../style-inject.es-746bb8ed.js';
import '../poll-option/index.js';
import '../../defaults-0542c304.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../poll-option/PollGridOption.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../../RemoveOption-0fb59667.js';
import '../../assets/icons/RemoveIcon.js';
import '../poll-option/PollOptionBase.js';
import '../poll-option/types.js';
import '../poll-context/types.js';
import '../../assets/icons/NonEditableIcon.js';
import '../../assets/icons/CheckIcon.js';
import '../image-upload/ImageUpload.js';
import '../image-upload/types.js';
import '../../assets/icons/LoaderIcon.js';
import '../../assets/icons/ReplaceIcon.js';
import '../text-field/TextField.js';
import 'lodash';
import '../poll-option/PollListOption.js';
import '../poll-option/webview/PollListOptionWebview.js';
import '../../option-webview-c29b68a5.js';
import '../poll-option/webview/PollGridOptionWebview.js';
import '../poll-header/PollHeader.js';
import '../poll-context/PollContext.js';
import '../voted-users/VotedUsers.js';
import '../voted-users/types.js';
import '../../VotedUsersModal-b3691022.js';
import 'react-infinite-scroller';
import '../voted-users/VoterAvatar.js';
import '../voted-users/FallbackAvatar.js';
import '../../assets/icons/AddIcon.js';
import '../settings/edit-poll-section/EditPollSection.js';
import '../settings/layout-settings-section/LayoutSettingsSection.js';
import 'wix-rich-content-plugin-commons';
import '../../assets/icons/LayoutListIcon.js';
import '../../assets/icons/LayoutGridIcon.js';
import '../settings/design-settings-section/DesignSettingsSection.js';
import '../../assets/icons/ColorIcon.js';
import '../../assets/icons/GradientIcon.js';
import '../../assets/icons/ImageIcon.js';
import '../settings/poll-settings-section/PollSettingsSection.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const PollSettingsModal = ({ nodeId, activeTab, settings }) => {
  const { t, isMobile, experiments, languageDir } = useContext(RicosContext);
  const modalService = useContext(ModalContext) || {};
  const { getEditorCommands } = useContext(EditorContext);
  const [initialData, setInitialData] = useState();
  const [componentData, setComponentData] = useState();
  useEffect(() => {
    const componentData2 = getEditorCommands().getBlockComponentData(nodeId);
    setInitialData(componentData2);
    setComponentData(componentData2);
  }, []);
  const updateData = (data) => {
    setTimeout(() => {
      getEditorCommands().setBlock(nodeId, POLL_TYPE, __spreadProps(__spreadValues(__spreadValues({}, componentData), data), { id: nodeId }));
      setComponentData(__spreadValues(__spreadValues({}, componentData), data));
    }, 0);
  };
  const closeModal = () => {
    modalService.closeModal(pollModals.settings);
  };
  const onCancel = () => {
    updateData(initialData);
    closeModal();
  };
  return componentData ? /* @__PURE__ */ React.createElement(
    SettingsModal,
    {
      componentData,
      activeTab,
      helpers: {},
      experiments,
      t,
      isMobile,
      updateData,
      onSave: closeModal,
      onCancel,
      languageDir,
      settings
    }
  ) : null;
};

export { PollSettingsModal as default };
//# sourceMappingURL=SettingsModal.js.map
